import { TextField, Switch, FormControlLabel, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const LongTextQuestion = ({ question, updateQuestion, canEdit }) => {
  const { t } = useTranslation();

  // --- READ-ONLY VIEW ---
  if (!canEdit) {
    return (
      <Box sx={{ width: "100%" }}>
        <Typography variant="subtitle1" fontWeight={500} sx={{ mb: 1 }}>
          {question.questionText || t("admin.formCreation.untitledQuestion")}
          {question.isRequired && (
            <Typography component="span" color="error" sx={{ ml: 0.5 }}>
              *
            </Typography>
          )}
        </Typography>

        <TextField
          disabled
          fullWidth
          multiline
          minRows={3}
          placeholder={t("admin.formCreation.long") || "Long answer text..."}
          sx={{ pointerEvents: "none" }}
        />
      </Box>
    );
  }

  // --- EDIT VIEW ---
  return (
    <>
      {/* Question Text Input */}
      <TextField
        fullWidth
        label={t("admin.formCreation.long")}
        value={question.questionText}
        onChange={(e) => updateQuestion({ ...question, questionText: e.target.value })}
        sx={{ mb: 2 }}
      />

      {/* Required Switch */}
      <FormControlLabel
        control={
          <Switch
            checked={question.isRequired}
            onChange={(e) => updateQuestion({ ...question, isRequired: e.target.checked })}
          />
        }
        label={t("admin.formCreation.required")}
      />
    </>
  );
};

LongTextQuestion.propTypes = {
  question: PropTypes.shape({
    formId: PropTypes.number,
    questionText: PropTypes.string,
    fieldType: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    options: PropTypes.string,
    orderIndex: PropTypes.number,
  }).isRequired,
  updateQuestion: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default LongTextQuestion;
